import {from, Observable, of} from "rxjs";

export function getDevicePosition(): Observable<[number, number]> {
    return from(new Promise<[number, number]>((resolve, reject) => {

        navigator.geolocation.getCurrentPosition(resp => {
                resolve([resp.coords.longitude, resp.coords.latitude]);
            },
            err => {
                reject(err);
            });
    }));
}